import { useEffect } from "react"
import { debounce } from "lodash"

export function useBottomReachedDetector({ bottomOffset = 0, onReached }: { bottomOffset?: number; onReached(): void }): void {
  useEffect(() => {
    function listener(event: Event) {
      const { body, documentElement: html } = document
      const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
      if (window.scrollY + window.innerHeight >= height - bottomOffset) {
        onReached()
      }
    }

    const debouncedListener = debounce(listener, 300)

    window.addEventListener("scroll", debouncedListener, true)

    return () => window.removeEventListener("scroll", debouncedListener, true)
  }, [bottomOffset, onReached])
}
